// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__38sy3","breadcrumbItem":"Breadcrumb_breadcrumbItem__2cMc3","arrowBack":"Breadcrumb_arrowBack__39ZrJ"};